export default "__VITE_ASSET__ad798019__"